<template>
  <div class="custom-checkbox" :class="{ disabled: isDisabled }" @click="toggleCheck" :key="Math.random()">
    <input type="checkbox" :checked="isChecked" :disabled="isDisabled" @change="toggleCheck" />
    <span class="checkmark"></span>
  </div>
</template>

<script>
export default {
  name: 'CustomCheckbox',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isChecked() {
      return this.value;
    },
    isDisabled() {
      return this.disabled;
    }
  },
  methods: {
    toggleCheck() {
      if (!this.isDisabled) {
        const checked = !this.isChecked;
        this.$emit('input', checked);
        this.$emit('update-status', checked);
      }
    }
  }
};
</script>

<style scoped>
.custom-checkbox {
  display: inline-block;
  position: relative;
  width: 56px;
  height: 56px;
  cursor: pointer;
}

.custom-checkbox input {
  opacity: 0;
  width: 0;
  height: 0;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 56px;
  width: 56px;
  background-color: #fff;
  border: 2px solid #e2e8f0;
  border-radius: 4px;
}

.custom-checkbox input:checked + .checkmark {
  background-color: #48bb78;
  border-color: #48bb78;
}

.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

.custom-checkbox input:checked + .checkmark:after {
  display: block;
}

.custom-checkbox .checkmark:after {
  left: 20px;
  top: 14px;
  width: 10px;
  height: 20px;
  border: solid white;
  border-width: 0 4px 4px 0;
  transform: rotate(45deg);
}

.custom-checkbox.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.custom-checkbox.disabled .checkmark {
  background-color: #0000001f;
  border-color: #dcdcdc;
}
</style>
